<template>
  <div class="row">
    <div class="col col-md-12">
      <p v-if="itens.length == 0" style="margin-bottom: 0px">------</p>

      <div class="rowLista list-group list-group-flush">
        <div v-for="item in itens" :key="item.id" :item="item">
          <div
            class="text-left"
            v-if="filtroSituacao.indexOf(item.situacao) > -1"
          >
            <div class="row">
              <div class="col col-md-12 d-flex justify-content-start">
                <img
                  class="img-fluid"
                  src="/assets/bola.png"
                  style="max-height: 30px; margin-right: 10px; margin-top: 5px"
                  v-if="icone"
                />
                <h5
                  style="margin-top: 8px; margin-right: 10px"
                  v-if="!icone && item.situacao !== 3"
                >
                  <b>#</b>
                </h5>
                <button
                  @click="abrirEvento(item, true)"
                  v-if="!icone && item.situacao == 3"
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  style="
                    margin-left: 10px;
                    margin-right: 5px;
                    zoom: 0.9;
                    height: 35px;
                    margin-top: 10px;
                  "
                  title="Sem Radar"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-camera-video"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
                    />
                  </svg>
                </button>
                <button
                  @click="abrirEvento(item, false)"
                  v-if="!icone && item.situacao == 3"
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  style="
                    margin-left: 5px;
                    margin-right: 15px;
                    zoom: 0.9;
                    height: 35px;
                    margin-top: 10px;
                  "
                  title="Com Radar"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-clipboard-data"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
                    />
                    <path
                      d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                    />
                    <path
                      d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                    />
                  </svg>
                </button>
                <a
                  @click="abrirEvento(item, false)"
                  role="button"
                  v-bind:style="{
                    cursor: item.situacao == 3 ? 'pointer' : 'default',
                  }"
                >
                  <h6
                    style="margin-top: 10px"
                    v-bind:style="{
                      'margin-top': item.situacao == 3 ? '15px' : '10px',
                    }"
                  >
                    <small>
                      {{ formatarHora(item) }}
                    </small>
                    -
                    {{ item.nome }}
                    <small v-if="item.situacao == 2">
                      <small>Invisivel</small>
                    </small>
                  </h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListEventoHome3",
  components: {},
  props: {
    itens: { type: Array },
    filtroSituacao: { type: Array, default: () => [] },
    icone: { type: Boolean, default: true },
    gmt: { type: Number, default: -3 },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    formatarHora(evento) {
      var hora = evento.dataHora.toString().padStart(2, "0");
      var minuto = evento.dataMinuto.toString().padStart(2, "0");

      try {
        var data = new Date();
        data.setHours(evento.dataHora + 3 + this.gmt);
        data.setMinutes(evento.dataMinuto);

        hora = data.getHours();
        minuto = data.getMinutes();
      } catch (err) {
        console.log(err);
      }

      return (
        hora.toString().padStart(2, "0") +
        ":" +
        minuto.toString().padStart(2, "0")
      );
    },
    abrirEvento(item, limpo) {
      var url = "/view/" + item._id;

      if (limpo) {
        url = url + "?view=clean";
      }

      if (
        item.situacao == 3 ||
        this.$sessao.usuario.tipoUsuario == "Administrador"
      ) {
        var altura = "710";

        if (this.retornaSite() == "Stream1x2" && limpo) {
          altura = "370";
        }

        window.open(
          url,
          "newwindow_" + Date.now(),
          "scrollbars=1,width=450,height=" + altura,
          true
        );
      }
    },
  },
  mounted() {},
  data: function () {
    return {};
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 0px !important;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>

